import { useRouter } from 'next/router';

import { Head } from '@playbooks/ui/components/head';

const acronyms = new Map([
	['api', 'API'],
	['cli', 'CLI'],
	['mcp', 'MCP'],
	['oauth', 'OAuth'],
	['seo', 'SEO'],
]);

const formatTitleSegment = (segment: string) =>
	decodeURIComponent(segment)
		.split('-')
		.filter(Boolean)
		.map(word => acronyms.get(word.toLowerCase()) || `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
		.join(' ');

const formatPageTitle = (baseTitle: string, path = '') => {
	const segments = path.split(/[?#]/)[0].split('/').filter(Boolean).map(formatTitleSegment).filter(Boolean);

	return segments.length ? [baseTitle, ...segments].join(' | ') : baseTitle;
};

const PageHead = ({ seo, title }: { seo: any; title?: string }) => {
	const router = useRouter();
	const path = router.asPath?.split(/[?#]/)[0] || '/';
	const computedTitle = title || formatPageTitle(seo.title, path);
	const url = seo.baseUrl ? `${seo.baseUrl}${path === '/' ? '' : path}` : undefined;

	return <Head {...seo} title={computedTitle} url={url} />;
};

export { formatPageTitle, PageHead };
